exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row1[data-v-41a77c1d],\n.row2[data-v-41a77c1d],\n.row3[data-v-41a77c1d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
